/** @format */

const template = `
<ng-repeat ng-if="!$ctrl.isPlainDisplayMode" ng-repeat="searchParameterKey in $ctrl.searchParamKeys | filter:$ctrl.searchParameterIsValid">
  <sis-tooltip
    [tooltip-block-element]="true"
    tooltip-class="tooltip-wide"
    [tooltip-enabled]="$ctrl.showSearchParameterTooltip(searchParameterKey)">
    <div class="tag disabled no-editing sis-tooltip-trigger-content">
      <div class="tag-content">
        <div class="tag-title">
          <span>{{::'SEARCH.FILTER_TAGS.' + $ctrl.searchParameterOptions[searchParameterKey].name | translate}}</span>
        </div>
        <div class="tag-description">
          <span>{{$ctrl.getParameterValue(searchParameterKey)}}</span>
        </div>
      </div>
    </div>
    <div class="sis-tooltip-content">
      <ul class="search-parameter-tooltip no-list-style-type">
        <li ng-repeat="parameter in $ctrl.getFullParameterValue(searchParameterKey) track by $index">{{parameter}}</li>
      </ul>
    </div>
  </sis-tooltip>
</ng-repeat>
<div ng-if="$ctrl.isPlainDisplayMode">
  <ng-repeat ng-repeat="searchParameterKey in $ctrl.searchParamKeys | filter:$ctrl.searchParameterIsValid">
    <div class="tag-plain-display-content">
      {{::'SEARCH.FILTER_TAGS.' + $ctrl.searchParameterOptions[searchParameterKey].name | translate}}:
      {{$ctrl.getParameterValue(searchParameterKey)}}
    </div>
  </ng-repeat>
</div>
`;
export default template;
